import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  style: {"text-transform":"capitalize"}
}

import DataProviderEntityCard
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/DataProviderEntityCard.vue";
import {computed, inject, ref} from "vue";
import {
    DataProviderManageEntityTabInjection
} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/editTab/Inteface";
import {__} from "~/ts/library/Translate";

import OperatorApplicationClientDataProviderEntityHistoryOpenApiModel = OperatorApplicationApi.OperatorApplicationClientDataProviderEntityHistoryOpenApiModel;
import OperatorGetParamsIntegrationDataProviderEntityTypeOpenApiModel = OperatorApplicationApi.OperatorGetParamsIntegrationDataProviderEntityTypeOpenApiModel;

const __default__ = {
    name: "ClientInfoDataProviderCardEntityType"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    historyItems: {},
    entityType: {},
    userdata: {},
    platform: {}
  },
  emits: ["manage"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit

let openManageDataProviderEntity = inject(DataProviderManageEntityTabInjection, null);
const MAX_ITEMS = 3;
let showAll = ref(false);
let displayedItems = computed(() => {
    if (showAll.value) {
        return props.historyItems;
    } else {
        return props.historyItems.slice(0, MAX_ITEMS);
    }
});


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayedItems), (item) => {
      return (_openBlock(), _createBlock(DataProviderEntityCard, {
        "history-item": item,
        "entity-type": __props.entityType,
        username: __props.userdata.username,
        platform: __props.platform,
        "is-edit-available": !!_unref(openManageDataProviderEntity),
        onEdit: ($event: any) => (_unref(emits)('manage', item.entityId))
      }, null, 8, ["history-item", "entity-type", "username", "platform", "is-edit-available", "onEdit"]))
    }), 256)),
    (__props.historyItems.length > MAX_ITEMS)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            class: "d-block w-100 mb-3 h-auto p-1",
            link: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(showAll) //@ts-ignore
 ? showAll.value = !_unref(showAll) : showAll = !_unref(showAll)))
          }, {
            default: _withCtx(() => [
              (_unref(showAll))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Свернуть ")
                  ], 64))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(__)("еще %d", __props.historyItems.length - _unref(displayedItems).length)), 1))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})